<div class="form-group" [class.required]="isRequired" [class.disabled]="isDisabled" [formGroup]="parentForm" [class.inline]="isInline">
  <mat-radio-group [formControlName]="controlName" class="radio-group-checkboxes">
    <mat-radio-button class="radio-button-checkboxes" *ngFor="let item of collection" [value]="item[keyPropertyName]">
      <span class="fs-14">{{ item[valuePropertyName] }}</span>
    </mat-radio-button>
  </mat-radio-group>
</div>
